import React, {useState} from "react"

function RegistrationInput(props) {
    const [errorText] = useState(<h3 id="registrationError"><em>Product key not recognised. Please try again.</em></h3>)
    
    return (
            <div id="registrationInput">
                <h2><em>Please Enter Your Product Key To Play</em></h2>
                <form>
                    <input placeholder="Product Key" onChange={props.handleChange} value={props.value} />
                    <br />
                    {props.error ? errorText : ""}
                    <button className="standardButton" onClick={props.handleClick}>Log In</button>
                </form>
            </div>
    )
}

export default RegistrationInput